module.exports = __webpack_public_path__ + "img/133.6.4bd79227.png";